module.exports = __webpack_public_path__ + "exo-latin-900.c45295dd710f6c155910.eot";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/typeface-exo/files/exo-latin-900.eot
// module id = ../../../../typeface-exo/files/exo-latin-900.eot
// module chunks = styles